<template>
  <div class="storedValueCardManage">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>营销</el-breadcrumb-item>
      <el-breadcrumb-item>储值卡</el-breadcrumb-item>
      <el-breadcrumb-item>储值卡设置</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="basicInfo">
      <h3 class="title-t mg-b-30">基础信息</h3>
      <el-form ref="form" :model="basicInfoForm" label-width="150px">
        <el-form-item label="储值档位一">
          <div class="flex align-center">
            <p>
              储值<el-input
                type="number"
                v-model="basicInfoForm.stored1"
                class="ipt"
                placeholder="请输入"
                ><template slot="prepend">元</template></el-input
              >
            </p>
            <p>
              赠送<el-input
                type="number"
                v-model="basicInfoForm.give1"
                class="ipt"
                placeholder="请输入"
                ><template slot="prepend">元</template></el-input
              >
            </p>
          </div>
        </el-form-item>
        <el-form-item label="储值档位二">
          <div class="flex align-center">
            <p>
              储值<el-input
                type="number"
                v-model="basicInfoForm.stored2"
                class="ipt"
                placeholder="请输入"
                ><template slot="prepend">元</template></el-input
              >
            </p>
            <p>
              赠送<el-input
                type="number"
                v-model="basicInfoForm.give2"
                class="ipt"
                placeholder="请输入"
                ><template slot="prepend">元</template></el-input
              >
            </p>
          </div>
        </el-form-item>
        <el-form-item label="储值档位三">
          <div class="flex align-center">
            <p>
              储值<el-input
                type="number"
                v-model="basicInfoForm.stored3"
                class="ipt"
                placeholder="请输入"
                ><template slot="prepend">元</template></el-input
              >
            </p>
            <p>
              赠送<el-input
                type="number"
                v-model="basicInfoForm.give3"
                class="ipt"
                placeholder="请输入"
                ><template slot="prepend">元</template></el-input
              >
            </p>
          </div>
        </el-form-item>
        <el-form-item label="储值档位四">
          <div class="flex align-center">
            <p>
              储值<el-input
                type="number"
                v-model="basicInfoForm.stored4"
                class="ipt"
                placeholder="请输入"
                ><template slot="prepend">元</template></el-input
              >
            </p>
            <p>
              赠送<el-input
                type="number"
                v-model="basicInfoForm.give4"
                class="ipt"
                placeholder="请输入"
                ><template slot="prepend">元</template></el-input
              >
            </p>
          </div>
        </el-form-item>
        <el-form-item label="储值档位五">
          <div class="flex align-center">
            <p>
              储值<el-input
                type="number"
                v-model="basicInfoForm.stored5"
                class="ipt"
                placeholder="请输入"
                ><template slot="prepend">元</template></el-input
              >
            </p>
            <p>
              赠送<el-input
                type="number"
                v-model="basicInfoForm.give5"
                class="ipt"
                placeholder="请输入"
                ><template slot="prepend">元</template></el-input
              >
            </p>
          </div>
        </el-form-item>
        <el-form-item label="储值档位六">
          <div class="flex align-center">
            <p>
              储值<el-input
                type="number"
                v-model="basicInfoForm.stored6"
                class="ipt"
                placeholder="请输入"
                ><template slot="prepend">元</template></el-input
              >
            </p>
            <p>
              赠送<el-input
                type="number"
                v-model="basicInfoForm.give6"
                class="ipt"
                placeholder="请输入"
                ><template slot="prepend">元</template></el-input
              >
            </p>
          </div>
        </el-form-item>
        <el-form-item label="是否开启储值渠道">
          <el-switch
            v-model="basicInfoForm.channel_status"
            :active-value="1"
            :inactive-value="2"
            active-color="#13ce66"
            inactive-color="gray"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="是否开启储值退卡">
          <el-switch
            v-model="basicInfoForm.return_status"
            :active-value="1"
            :inactive-value="2"
            active-color="#13ce66"
            inactive-color="gray"
          >
          </el-switch>
        </el-form-item>
      </el-form>
    </div>
    <div class="operateBtn">
      <el-button size="mini" type="primary" @click="submit">保存</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: "storedValueCardManage",
  data() {
    return {
      imageUrl: "",
      isShow: false,
      basicInfoForm: {
        channel_status: 2,
        give1: "",
        give2: "",
        give3: "",
        give4: "",
        give5: "",
        give6: "",
        return_status: 2,
        stored1: "",
        stored2: "",
        stored3: "",
        stored4: "",
        stored5: "",
        stored6: "",
      },
    };
  },
  created() {
    this.axios({
      method: "get", //请求方法
      headers: {
        "Content-Type": "application/json",
        "X-Access-Token": this.storage.get("__token"),
        Authorization: `Bearer ${this.storage.get("__token")}`,
      },
      url: ` https://time.api.boyalife.cn/v1/cms/StoredCardSetting/1`,
    })
      .then((res) => {
        let a = res.data.result;
        for (let i in a) {
          this.basicInfoForm[i] = Number(a[i]);
        }
      })
      .catch((err) => {
        this.$message.error(err.response.data.error.message);
      });
  },
  methods: {
    submit() {
      for (let i in this.basicInfoForm) {
        this.basicInfoForm[i] = Number(this.basicInfoForm[i]);
      }
      this.axios({
        method: "put", //请求方法
        headers: {
          "Content-Type": "application/json",
          "X-Access-Token": this.storage.get("__token"),
          Authorization: `Bearer ${this.storage.get("__token")}`,
        },
        data: this.basicInfoForm,
        url: ` https://time.api.boyalife.cn/v1/cms/StoredCardSetting/1`,
      })
        .then((res) => {
          this.$message.success("保存成功！");
        })
        .catch((err) => {
          this.$message.error(err.response.data.error.message);
        });
    },
  },
};
</script>
<style scoped>
.storedValueCardManage {
  background: #f2f2f2;
  margin-bottom: 80px;
}
.basicInfo {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
}
.avatar-uploader >>> .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.el-form {
  width: 100%;
}
>>> .ipt {
  width: 200px;
  margin: 0 10px;
}
>>> .el-checkbox {
  margin-right: 0;
}
p {
  line-height: 40px;
}
</style>
